import { useEffect, useState, useCallback, useRef } from "react";
import { Content } from "@jobber/components/Content";
import { Card } from "@jobber/components/Card";
import { Button } from "@jobber/components/Button";
import TagCloud from "./TagCloud";

function Offcanvas({ tagCloudHandler, tagCloud, tagReload, setTagReload }) {
  const dropdownRef = useRef(null);
  const [width, setWidth] = useState(400);
  const [isHovered, setIsHovered] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  useEffect(() => {
    setTagReload(false);
    setTimeout(() => {
      setTagReload(true);
    }, 1);
  }, [tagCloud])

  const startResizing = useCallback((mouseDownEvent) => {
    mouseDownEvent.preventDefault();
    setIsResizing(true);

    const onMouseMove = (mouseMoveEvent) => {
      const newWidth = window.innerWidth - mouseMoveEvent.clientX;
      const maxWidth = window.innerWidth * 0.75;
      if (newWidth > 300 && newWidth < maxWidth) {
        setWidth(newWidth);
      }
    };

    const onMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }, []);

  return (
    <div
      className={`offcanvas offcanvas-end ${tagCloud ? "show" : ""}`}
      style={{
        width: `${width}px`,
        transition: isResizing ? "none" : "width 0.3s ease",
      }}
      ref={dropdownRef}
      tabIndex="-1"
      id="offcanvasRight"
    >
      <div
        onMouseDown={startResizing}
        onDoubleClick={() => setWidth(400)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "5px",
          cursor: "ew-resize",
          zIndex: 1000,
          backgroundColor: isHovered ? "rgba(0, 0, 0, 0.1)" : "transparent",
          transition: "background-color 0.2s ease",
        }}
      />
      <div className="offcanvas-body">
        <Card
          header={{
            title: "Tag Cloud",
            action: <Button label="X" onClick={tagCloudHandler} />,
          }}
        >
          <Content>
            {tagReload ? (
              <TagCloud
                tagCloud={tagCloud}
                reload={() => {
                  setTagReload(false);
                  setTimeout(() => {
                    setTagReload(true);
                  }, 1);
                }}
              />
            ) : (
              ""
            )}
          </Content>
        </Card>
      </div>
    </div>
  );
}

export default Offcanvas;
